/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface UpdateDeviceAuthorizationRequest
 */
export interface UpdateDeviceAuthorizationRequest {
    /**
     *
     * @type {string}
     * @memberof UpdateDeviceAuthorizationRequest
     */
    mode?: UpdateDeviceAuthorizationRequestModeEnum;
    /**
     * If Mode=AutomaticBasicAuth, True to have device service regenerate new key, false if you do not intend to replace the key if it is already set.
     * @type {boolean}
     * @memberof UpdateDeviceAuthorizationRequest
     */
    regenerate?: boolean;
    /**
     * If Mode=ManualBasicAuth, 20 character unique secret key that will be sent to the charger. When IsAuthKeyHexString is true, the expected key is 40 character hex representation instead. May be null.
     * @type {string}
     * @memberof UpdateDeviceAuthorizationRequest
     */
    authorizationKey?: string;
    /**
     * Set to true if AuthorizationKey is a 40 character hex representation of the secret key
     * @type {boolean}
     * @memberof UpdateDeviceAuthorizationRequest
     */
    isAuthKeyHexString?: boolean;
}

/**
 * @export
 */
export const UpdateDeviceAuthorizationRequestModeEnum = {
    LegacyBasicAuth: "LegacyBasicAuth",
    AutomaticBasicAuth: "AutomaticBasicAuth",
    ManualBasicAuth: "ManualBasicAuth",
    None: "None",
    Reject: "Reject",
} as const;
export type UpdateDeviceAuthorizationRequestModeEnum =
    (typeof UpdateDeviceAuthorizationRequestModeEnum)[keyof typeof UpdateDeviceAuthorizationRequestModeEnum];

/**
 * Check if a given object implements the UpdateDeviceAuthorizationRequest interface.
 */
export function instanceOfUpdateDeviceAuthorizationRequest(
    value: object,
): value is UpdateDeviceAuthorizationRequest {
    return true;
}

export function UpdateDeviceAuthorizationRequestFromJSON(
    json: any,
): UpdateDeviceAuthorizationRequest {
    return UpdateDeviceAuthorizationRequestFromJSONTyped(json, false);
}

export function UpdateDeviceAuthorizationRequestFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): UpdateDeviceAuthorizationRequest {
    if (json == null) {
        return json;
    }
    return {
        mode: json["mode"] == null ? undefined : json["mode"],
        regenerate: json["regenerate"] == null ? undefined : json["regenerate"],
        authorizationKey:
            json["authorizationKey"] == null
                ? undefined
                : json["authorizationKey"],
        isAuthKeyHexString:
            json["isAuthKeyHexString"] == null
                ? undefined
                : json["isAuthKeyHexString"],
    };
}

export function UpdateDeviceAuthorizationRequestToJSON(
    value?: UpdateDeviceAuthorizationRequest | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        mode: value["mode"],
        regenerate: value["regenerate"],
        authorizationKey: value["authorizationKey"],
        isAuthKeyHexString: value["isAuthKeyHexString"],
    };
}
